export const mutations = {
  SET_BOUNDARIES(state, payload) {
    state.boundaries = payload
  },

  SET_CURRENT_BOUNDARY(state, payload) {
    state.currentBoundary = payload
  },

  SET_LOADING(state, payload) {
    state.isLoading = payload
  },

  SET_HOVERED_BOUNDARY_PROJECT_ID(state, payload) {
    state.hoveredBoundaryProjectId = payload
  },
}
